import styled from '@emotion/styled'
import { makeModifiable, Mods } from '../../primitives/core/mods'
import React, { HTMLProps, PropsWithChildren } from 'react'
import { TextEmphasisMods, TextEmphasisProps } from '../..'

const StyledP = makeModifiable(styled.p<PropsWithChildren<Props>>`
	font-size: 1rem;
	line-height: 148%;
	${TextEmphasisMods}
`)

type Props = Mods & TextEmphasisProps & Omit<HTMLProps<HTMLParagraphElement>, 'as'> & { as?: React.ElementType<any> }

/**
 * Text Paragraph Styles
 * Use the boolean text formatting props: small, big, bold, light, and italic
 */
export const Paragraph: React.FC<React.PropsWithChildren<Props>> = ({ children, modifiers, ...rest }) => (
	<StyledP {...rest} modifiers={modifiers}>
		{children}
	</StyledP>
)

/**
 * Use a span within a {@link Paragraph} to change the formatting of the included text
 */
export const Span = styled.span`
	${TextEmphasisMods}
`
